import Vue from "vue";
import { expertAPI } from "@/utils/apiUrls";
import usercase from "./usercase/index";

export default {
  namespaced: true,

  modules: {
    usercase,
  },

  state: {
    companies: [],
    usercases: [],
  },

  getters: {},

  mutations: {
    updateCompanies(state, payload) {
      state.companies = payload;
    },

    updateUsercases(state, payload) {
      state.usercases = payload;
    },
  },

  actions: {
    refreshData({ dispatch }) {
      dispatch("refreshCompanies");
      dispatch("refreshCases");
    },

    refreshCompanies({ commit }) {
      Vue.axios
        .get(expertAPI.GetCompaniesURL)
        .then((resp) => commit("updateCompanies", resp.data))
        .catch((err) => console.error(err));
    },

    async refreshCases({ commit }) {
      await Vue.axios
        .get(expertAPI.GetCasesURL)
        .then((resp) => commit("updateUsercases", resp.data))
        .catch((err) => console.error(err));
    },
  },
};
